import React, { useContext, useEffect, useState } from 'react';
import '../assets/css/admin/adminlayout/adminlayout.css';
import AdminSidebar from 'components/admin/sidebar/AdminSidebar.js';
import AdminHeader from 'components/admin/header/AdminHeader.js';
import AppContext from 'context/AppContext';

const AdminMasterLayout = ({ children, pageTitle = 'Dashboard' }) => {
  
  // const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);
  const {setAuthToken,setLoggedInAdmin} = useContext(AppContext);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(
  JSON.parse(localStorage.getItem('sidebarExpanded')) ?? true
);

const handleSidebarToggle = () => {
  const newState = !isSidebarExpanded;
  setIsSidebarExpanded(newState);
  localStorage.setItem('sidebarExpanded', JSON.stringify(newState));
};
useEffect(()=> {
  const authToken=localStorage.getItem('authToken');
  setAuthToken(authToken);
  const savedAdmin = JSON.parse(localStorage.getItem("loggedInAdmin"))
  setLoggedInAdmin(savedAdmin);

},[]);



  // ==========================================
  // RENDER - Complete Dashboard Layout
  // ==========================================
  
  return (
    <div className="admindashboard-layout">
      
      {/* SIDEBAR - Pass toggle handler */}
      <AdminSidebar 
        isCollapsed={!isSidebarExpanded}
        onToggle={handleSidebarToggle}
      />

      {/* MAIN CONTENT AREA - Adjusts with sidebar */}
      <div className={`admindashboard-main ${isSidebarExpanded ? 'adminmain-expanded' : 'adminmain-collapsed'}`}>
        
        {/* HEADER - Pass sidebar state */}
        <AdminHeader 
          pageTitle={pageTitle}
          isSidebarExpanded={isSidebarExpanded}
        />

        {/* CONTENT AREA - Children rendered here */}
        <main className="admindashboard-content">
          {children}
        </main>

      </div>
    </div>
  );
};

export default AdminMasterLayout;